/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Col, Dropdown, Modal, Row } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAppSelector } from "../../redux/Hooks/Hook";
import { LogoutUser } from "../../utilities";
import { Button, DropDown } from "../../components";
import { selectFacility } from "../../redux/Slice/Facilities/FacilitiesListSlice";
import { images } from "../../config/images";
import { UpdateDefaultFacility } from "../../utilities/api/user/user-service";
import { ToastContainer, toast } from "react-toastify";
import { resetVerifyUserSlice } from "../../redux/Slice/Auth/VerifyUserSlice";
import { resetProfileDetailSlice } from "../../redux/Slice/Profile/ProfileDetailSlice";
import { NotificationCount } from "../../redux/Slice/NotificationCount/NotificationCountSlice";
import { routingHelper } from "../../routing/RoutingHelper";

type RoutingTypes = {
  from: string[];
  to: string;
}

const InnerHeader = ({ role }: any) => {
  const { UserRole, UserDetails, UserFacilities } = useAppSelector(
    (state) => state.verifiedUser
  );
  const { AllFacilitiesData, SelectedFacility, errorMessage } = useAppSelector(
    (state) => state.facilityList
  );
  const { UserProfileDetails, profileErrorMessage } = useAppSelector((state) => state.profileDetail);
  const { Count } = useAppSelector(state => state.NotificationCount)

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [facilityArr, setFacilityArr] = useState<any[]>([]);
  const [defaultFacility, setDefaultFacility] = useState<any>();
  let Heading = "";
  let HeadingArr = [
    "Dashboard",
    "Dashboard",
    "Facilities",
    "Availability Check",
    "Courts",
    "Sports",
    "Users",
    "Reports",
    "Booking",
    "Coaching",
    "Coaching",
    "Stock",
    "Profile",
    "Notification",
    "Discount Offers",
    "Exit Booking",
    "History",
    "Settings",
    "Invoices"
  ];
  let HeadingCheck = [
    "dashboard",
    "",
    "facilit",
    "availability",
    "court",
    "sport",
    "user",
    "report",
    "booking",
    "coach",
    "session",
    "stock",
    "profile",
    "notification",
    "discount",
    "exit",
    "history",
    "setting",
    "generate"
  ];

  if (errorMessage || profileErrorMessage) {
    toast.error(errorMessage?.message || profileErrorMessage?.message)
  }

  HeadingCheck.forEach((item) => {
    if (location.pathname.includes(item)) {
      Heading = HeadingArr[HeadingCheck.indexOf(item)];
    }
  });


  const HandleRouting = () => {

    UserRole?.role?.name !== "END_USER" && routingHelper?.forEach((item: RoutingTypes) => {

      const validate = item.from.some((subitem: string) => {
        const path = location.pathname;
        const lastIndex = path.lastIndexOf('/');
        return (lastIndex !== -1 && lastIndex !== 0 ? path.substring(0, lastIndex).trim() : path) === subitem
      })

      if (validate) {
        navigate(item.to);
      }
    })

  }


  const handleLogout = async () => {
    const result = await LogoutUser();
    if (result.status === 200) {
      dispatch(resetVerifyUserSlice());
      dispatch(resetProfileDetailSlice());
      localStorage.removeItem("device-uuid");
      localStorage.removeItem("authToken");
      localStorage.removeItem("device-token");
      navigate("/");
    }
    if (result.status === 200) {
      toast.success(result.data.message);
    } else {
      toast.error(result.response.data.message);
    }
  };
  const handleProfile = () => {
    navigate("/profile");
  };

  const UpdateFacility = async (id: string) => {
    const result = await UpdateDefaultFacility({
      facilityId: id ? Number(id) : "",
    });
    if (result.status !== 200) {
      toast.error(result.response.data.message);
    }
  };

  const handleChangeFacility = (value: string) => {
    UpdateFacility(value);
    dispatch(selectFacility(value));
  };

  useEffect(() => {
    if (["SUPER_ADMIN", "END_USER"].includes(UserRole?.role?.name)) {
      setFacilityArr(AllFacilitiesData);
    } else {
      let arr = UserFacilities.map((item: any) => item.facility);
      setFacilityArr(arr);
    }
    let DefaultFacility = SelectedFacility
      ? SelectedFacility
      : UserDetails?.defaultFacility
        ? UserDetails?.defaultFacility?.id
        : "";
    setDefaultFacility(DefaultFacility);
    dispatch(selectFacility(DefaultFacility as string));
  }, [UserFacilities, AllFacilitiesData]);

  let FacilityDropdownValue =
    SelectedFacility != null || SelectedFacility != undefined
      ? SelectedFacility
      : defaultFacility;


  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const facilityAddress = AllFacilitiesData.find((item: any) => item.id == FacilityDropdownValue)



  return (
    <>
      {UserRole?.role?.name &&
        (role !== "POS_ADMIN" ? (
          <div
            className="container-fluid g-0 text-end"
            style={{ height: "90px" }}
          >
            <Row className="align-items-center h-100 row">
              <Col lg={5}>
                <div className="d-flex align-items-center">
                  {role === "END_USER" && (
                    <Link to="./customer-dashboard">
                      <img
                        src={images.powerplaylogo.default}
                        alt="Powerplay"
                        className="me-4"
                      />
                    </Link>
                  )}
                  <h3 className="head-text mb-0 pe-auto" onClick={HandleRouting}>{Heading}</h3>
                </div>
              </Col>
              <Col lg={7}>
                {!location.pathname.includes("facilit") &&
                  !location.pathname.includes("sport") &&
                  !location.pathname.includes("session-detail") &&
                  !location.pathname.includes("customer-booking") &&
                  !location.pathname.includes("customer-court-booking-reschedule") &&
                  !location.pathname.includes("user") && (
                    <>
                      <span className="form-label">Select Facility </span>
                      <div className={role === "END_USER" ? "facility-dropdown map-drop" : "facility-dropdown"}>
                        <DropDown
                          value={FacilityDropdownValue}
                          onChange={(e: any) =>
                            handleChangeFacility(e.target.value as string)
                          }
                          id="facility-dropdown"
                          name="facility-dropdown"
                          className="select-dropdown"
                          style={{ cursor: "pointer" }}
                          disabled={
                            location.pathname.includes("update-court") ||
                            location.pathname.includes("update-sell-stock")
                          }
                        >
                          <option hidden value="">
                            Select facility (All)
                          </option>
                          <option value=""> All </option>
                          {facilityArr?.map((item) => {
                            return (
                              <option value={item.id} key={item.id}>
                                {item.name}
                              </option>
                            );
                          })}
                        </DropDown>
                        {role === "END_USER" && <>

                          <span className="map-icon ms-2 position-absolute top-0">

                            <img src={images.mapicon.default} alt="" onClick={handleShow} style={{ cursor: "pointer" }} />

                          </span></>}
                      </div>

                    </>
                  )}
                {role === "END_USER" &&
                  <div className="text-end d-inline-block user-profile">
                    <Dropdown align="end">
                      <Dropdown.Toggle variant="primary" id="dropdown-basic">
                        <Link to="/notification" className="link-dark text-decoration-none">
                          <span
                            onClick={() => dispatch(NotificationCount("0"))}
                            className="icon-notification-icon notification-count"
                            data-count={Count !== "0" && Count !== "undefined" ? Count : null}
                          ></span>
                        </Link>
                      </Dropdown.Toggle>
                    </Dropdown>
                  </div>
                }
                <div className="text-end d-inline-block user-profile">
                  <Dropdown align="end">
                    <Dropdown.Toggle variant="success" id="dropdown-basic">
                      <a className="link-dark text-decoration-none">
                        {UserProfileDetails.firstName || UserDetails.firstName}{" "}
                        {UserProfileDetails.lastName || UserDetails.lastName}{" "}
                        <img
                          src={
                            UserProfileDetails.userImage ||
                            UserDetails?.userImage ||
                            images.imgupload.default
                          }
                          alt="user"
                          width="40"
                          height="40"
                          className="border border-1 rounded-circle"
                        />
                      </a>
                    </Dropdown.Toggle>

                    <Dropdown.Menu>

                      <Dropdown.Item onClick={handleProfile}>
                        Profile
                      </Dropdown.Item>

                      <Dropdown.Item onClick={handleLogout}>
                        Logout
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              </Col>
            </Row>
          </div>
        ) : (
          <>
            <div className="pos-header g-0 text-end">
              <Row className="align-items-center h-100 px-2">
                <Col lg={6}>
                  <div className="d-flex align-items-center me-4">
                    <img
                      src={images.powerplaylogowhite.default}
                      height="37"
                      className=""
                      alt="Powerplay"
                    />
                  </div>
                </Col>
                <Col lg={4} className="text-end">
                  <h6 className="text-white">Facility : {UserFacilities[0]?.facility?.name}</h6>
                </Col>
                <Col lg={2} className="text-end">
                  <Button
                    bname="Logout"
                    className="btn btn-primary rounded-1"
                    onClick={handleLogout}
                    id="logout"
                    name="logout"
                  />
                </Col>
              </Row>
            </div>
          </>
        ))}
      <ToastContainer />
      <Modal show={show} onHide={handleClose} aria-labelledby="contained-modal-title-vcenter"
        centered>
        <Modal.Header closeButton>
          <Modal.Title>Facility Address</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <address>{facilityAddress?.address}</address>
        </Modal.Body>
        <Modal.Footer>
          {facilityAddress?.latitude && facilityAddress?.longitude && (
            <button
              className="btn btn-primary"
              onClick={() => {
                navigator.geolocation.getCurrentPosition(
                  (pos) => {
                    const { latitude: lat, longitude: lng } = pos.coords;
                    window.open(
                      `https://www.google.com/maps/dir/?api=1&origin=${lat},${lng}&destination=${facilityAddress.latitude},${facilityAddress.longitude}`,
                      "_blank"
                    );
                  },
                  () => {
                    window.open(
                      `https://www.google.com/maps/dir/?api=1&destination=${facilityAddress.latitude},${facilityAddress.longitude}`,
                      "_blank"
                    );
                  }
                );
              }}
            >
              Get Directions
            </button>
          )}
        </Modal.Footer>
      </Modal>
    </>
  );
};
export { InnerHeader };
